import React from "react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020617] to-[#0f172a] text-white px-6 md:px-16 py-12">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold text-blue-400">Terms & Conditions</h1>
        <p className="text-sm text-gray-400">Last updated: October 30, 2025</p>

        <section>
          <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
          <p className="text-gray-300">
            Welcome to <strong>Aeronauts</strong>. These Terms & Conditions govern your access and use of our website,
            platform, and dashboard features. By using the Service, you agree to comply with these Terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">2. Account Registration — User ID & Password</h2>
          <ul className="list-disc ml-6 text-gray-300 space-y-2">
            <li>
              You must register to access the dashboard and provide accurate information such as your name, email, and a
              unique user ID.
            </li>
            <li>
              You are responsible for keeping your credentials secure. Notify us immediately at{" "}
              <a href="mailto:aeronauts.nsut@gmail.com" className="text-blue-400 underline">
                aeronauts.nsut@gmail.com
              </a>{" "}
              if you suspect unauthorized use.
            </li>
            <li>We may suspend or terminate accounts for violations or suspicious activity.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">3. Dashboard Data & Ownership</h2>
          <ul className="list-disc ml-6 text-gray-300 space-y-2">
            <li>You retain ownership of all content and data you upload.</li>
            <li>
              Aeronauts may process or display your data only to provide the Service and improve functionality.
            </li>
            <li>
              We may generate anonymized insights from usage data, which never identify individual users.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">4. Acceptable Use</h2>
          <ul className="list-disc ml-6 text-gray-300 space-y-2">
            <li>Do not use the Service for illegal activities or to harass others.</li>
            <li>Do not attempt to access other users’ data or interfere with security mechanisms.</li>
            <li>Scraping or automated data extraction without consent is prohibited.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">5. Data Protection & Backups</h2>
          <p className="text-gray-300">
            We implement reasonable security measures, but users should maintain their own backups. We do not guarantee
            uninterrupted backups or permanent data storage.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">6. Limitation of Liability</h2>
          <p className="text-gray-300">
            Aeronauts shall not be liable for any indirect or consequential damages, including loss of data or revenue,
            resulting from the use of the Service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">7. Contact</h2>
          <p className="text-gray-300">
            For questions about these Terms, email us at{" "}
            <a href="mailto:aeronauts.nsut@gmail.com" className="text-blue-400 underline">
              aeronauts.nsut@gmail.com
            </a>
            .
          </p>
        </section>

        <p className="text-sm text-gray-500 pt-6">
          © {new Date().getFullYear()} Aeronauts Drone Society. All rights reserved.
        </p>
      </div>
    </div>
  );
}
